'use strict';

const cache = {
    $body: $('body'),
};

$(() => {
    cache.$body.on('click', '.js-menulist-dropdown-toggle', function (e) {
        e.preventDefault();
        let $content = $(this).siblings('.js-menulist-dropdown-content-wrapper').first();

        $content.toggleClass('show');
        $('.menulist-dropdown-wrapper').toggleClass('open');
    });

    if ($('.legal-page-menu-region').text() === '') {
        $('.legal-page-content-region').addClass('full-width container');
    }
});
